import { render, staticRenderFns } from "./ModulesTooltips.vue?vue&type=template&id=7b4f4a36&scoped=true"
import script from "./ModulesTooltips.vue?vue&type=script&lang=js"
export * from "./ModulesTooltips.vue?vue&type=script&lang=js"
import style0 from "./ModulesTooltips.vue?vue&type=style&index=0&id=7b4f4a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4f4a36",
  null
  
)

export default component.exports